// Wait for the entire DOM to be loaded before executing the script
document.addEventListener('DOMContentLoaded', () => {
  // Select the "Add to Cart" button
  const addToCartButton = document.querySelector('.btn.btn--large.add-to-cart');
  
  // Select all option selectors that are of type "listed"
  const listedSelectors = document.querySelectorAll('.option-selector[data-selector-type="listed"]');

  // Add a click event listener to the "Add to Cart" button
  addToCartButton.addEventListener('click', (e) => {
    // Find the first option selector that does not have a selected input
    const unselectedOption = Array.from(listedSelectors).find(selector => {
      return !selector.querySelector('input:checked');
    });

    // If there is an unselected option
    if (unselectedOption) {
      e.preventDefault(); // Prevent the form from being submitted

      // Scroll the page to the unselected option smoothly and center it in the view
      unselectedOption.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      // Add a visual shake effect to the unselected option
      unselectedOption.classList.add('shake-error');
      setTimeout(() => {
        unselectedOption.classList.remove('shake-error');
      }, 2000); // Remove the effect after 2 seconds

      // Change the label color to red and update text to prompt the user
      const label = unselectedOption.querySelector('legend, label');
      if (label) {
        label.classList.add('error-label'); // Add a class to change the label's appearance
        const optionType = unselectedOption.getAttribute('data-option');
        // Update the label text based on the option type
        if (optionType === 'Phone Model') {
          label.textContent = 'Please Choose your Phone Model';
        } else if (optionType === 'Color') {
          label.textContent = 'Please Choose a Color';
        }
      }
    }
  });
});